module.exports = __webpack_public_path__ + "img/28-social-urban-policy.e9abc5f4.jpg";